let showError = () => {};

export const registerErrorHandler = (fn) => {
  showError = fn;
};

const ERROR_MESSAGES = {
  500: 'Something went wrong on our end. Please try again later.',
  404: 'We couldn\u2019t find what you\u2019re looking for. It might have been moved or deleted.',
  403: 'You don\u2019t have permission to access this. Please check your access rights or contact support.',
  408: 'The request took too long. Please check your connection and try again.',
  503: 'Service is temporarily unavailable. Please try again in a few minutes.',
  400: 'Something\u2019s not right with the request. Please check the input.',
  401: 'Please sign in to continue.',
  409: 'This data already exists. Please review and try again.',
  422: 'Some fields are invalid. Please review and try again.',
  429: 'Too many requests. Please wait a moment and try again.'
};

export const handleHttpError = (status, serverMessage) => {
  if (!showError) return;
  const hasStatus = typeof status === 'number';
  const normalizedServerMessage =
    typeof serverMessage === 'string' ? serverMessage.trim() : '';
  const mappedMessage = hasStatus ? ERROR_MESSAGES[status] : '';

  const message = normalizedServerMessage || mappedMessage;
  if (!message) {
    return;
  }

  showError({ message, type: 'danger' });
};

export const showToastError = (message) => {
  if (!showError) return;
  showError({ message, type: 'danger' });
};

export const showToastSuccess = (message) => {
  if (!showError) return;
  showError({ message, type: 'success' });
};

export const showToastWarning = (message, duration = 30000) => {
  if (!showError) return;
  showError({ message, type: 'warning', duration });
};
